module.exports = __webpack_public_path__ + "static/media/RefreshIcon_Disabled_01.55c237e7.svg";